import { useEffect, useRef } from 'react';

const ACTIVITY_EVENTS = ['keydown', 'touchstart', 'click'];

export const useIdleTimer = ({ timeoutMs, isPaused, onIdle }) => {
  const timeoutRef = useRef(null);
  const onIdleRef = useRef(onIdle);

  useEffect(() => {
    onIdleRef.current = onIdle;
  }, [onIdle]);

  useEffect(() => {
    if (isPaused) {
      clearTimeout(timeoutRef.current);
      return undefined;
    }

    const resetTimeout = () => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(onIdleRef.current, timeoutMs);
    };

    ACTIVITY_EVENTS.forEach(event => window.addEventListener(event, resetTimeout));
    resetTimeout();

    return () => {
      clearTimeout(timeoutRef.current);
      ACTIVITY_EVENTS.forEach(event => window.removeEventListener(event, resetTimeout));
    };
  }, [isPaused, timeoutMs]);
};
